import { ProjectService } from './../project.service';
import { KnaufSellerLocation, KnaufSellersLocations, KanufSellerContact } from './../knauf-sellers-locations';
import { Location } from './../location';
import { Component, OnInit, ChangeDetectorRef, ViewChild } from '@angular/core';
import { GeocodeService } from '../geocode.service';
import { NgModel } from '@angular/forms';
import { FormsModule } from '@angular/forms';
import { sprzedawcy } from './../sprzedawcy'
import { Project } from './../project';
import {GoogleMap, MapAdvancedMarker, MapInfoWindow} from '@angular/google-maps';


@Component({
  selector: 'app-where-buy',
  templateUrl: './where-buy.component.html',
  styleUrls: ['./where-buy.component.sass']
})
export class WhereBuyComponent implements OnInit {
  title: string = "SPRAWDŹ, GDZIE KUPIĆ";
  subtitle: string = "W Strefach Koloru Knauf możesz zobaczyć próbki tynków na dużych ekspozytorach. W pozostałych punktach sprzedaży - na specjalnych wzornikach.";
  next: string = "/project-summary"
  prev: string = "/calculator"

  longitude: number;
  latitude: number;
  zoom: number = 12;
  address: string = "";
  location: Location = { lng: 21.012229, lat: 52.229676 };
  zipcode: string = "";
  city: string = "";
  sprzedawcy: KnaufSellerLocation[] = [];
  project: Project;

  options: google.maps.MapOptions = {

    mapId: "DEMO_MAP_ID",
  };
  @ViewChild('mapRef') mapRef: GoogleMap;
  center: google.maps.LatLngLiteral =  { lng: 21.012229, lat: 52.229676 };

  @ViewChild(MapInfoWindow) infoWindow!: MapInfoWindow;

  constructor(private geocodeService: GeocodeService,
    private ref: ChangeDetectorRef, private projectService: ProjectService) {



  }

  ngOnInit() {
    this.project = this.projectService.getProject();
    this.setCurrentLocation();
    this.sprzedawcy = sprzedawcy;

console.log(this.sprzedawcy)
  }
  public setCurrentLocation() {
    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition((position) => {
        if (!position) return;
        this.latitude = position.coords.latitude;
        this.longitude = position.coords.longitude;
        this.location = { lat: this.latitude, lng: this.longitude };
        this.zoom = 10;
        this.updateDistances();

        console.log(this.location);

        this.center = this.location;

      });
    }
  }

  showLocation() {
    const codeReg = /[0-9]{2}-[0-9]{3}/g;
    let zipcode = this.zipcode;
    if (zipcode.match(/[0-9]{5}/g)) {
      zipcode = this.zipcode = zipcode.slice(0, 2) + "-" + zipcode.slice(2, 5);
    }

    if (zipcode != '' && !zipcode.match(codeReg)) {
      alert("Wprowadzono błędny kod pocztowy");
      return;
    }
    this.address = "Polska " + zipcode + " " + this.city;
    // this.addressToCoordinates();
  }

  public onZipCodeChange() {

    if (this.zipcode.length == 2 && this.zipcode.match(/[0-9]{2}/g)) {
      this.zipcode = this.zipcode + '-';
    }
  }

  private rad(x) {
    return x * Math.PI / 180;
  };

  private getDistance(p1, p2) {
    var R = 6378137; // Earth’s mean radius in meter
    var dLat = this.rad(p2.lat - p1.lat);
    var dLong = this.rad(p2.lng - p1.lng);
    var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(this.rad(p1.lat)) * Math.cos(this.rad(p2.lat)) *
      Math.sin(dLong / 2) * Math.sin(dLong / 2);
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    var d = R * c;
    return Math.ceil(d / 1000); // returns the distance in meter
  }

  private updateDistances() {
    this.sprzedawcy.forEach(element => {
      element.distance = this.getDistance(element.location, this.location);
    });
    this.sprzedawcy.sort((a, b) => (a.distance > b.distance) ? 1 : ((b.distance > a.distance) ? -1 : 0));
    this.projectService.setClosestSellers(this.sprzedawcy.slice(0, 3));
  }

  // addressToCoordinates() {
  //   this.geocodeService.geocodeAddress(this.address)
  //     .subscribe((location: Location) => {
  //       if (location.lat ==0 && location.lng ==0) {
  //         alert("Nie znaleziono szukanego adresu.");
  //         return;
  //       }
  //       this.location = location;
  //       this.updateDistances();
  //       this.ref.detectChanges();
  //     }
  //     );
  // }
  // delay(ms: number) {
  //   return new Promise(resolve => setTimeout(resolve, ms));
  // }
  // async test() {
  //   let seller = new KnaufSellerLocation();
  //   let sellers: KnaufSellerLocation[] = [];
  //   let contact = new KanufSellerContact;
  //   for (let entry of KnaufSellersLocations) {
  //     if (seller.company && seller.company != entry.company) {
  //       seller.contacts.push(contact);
  //       let address = seller.zipcode + " " + seller.city + " " + seller.address;
  //       let index = sellers.push(seller) - 1;
  //       seller = new KnaufSellerLocation();
  //       contact = new KanufSellerContact;
  //       this.geocodeService.geocodeAddress(address)
  //         .subscribe((location: Location) => {
  //           sellers[index].location = location;
  //           this.ref.detectChanges();
  //           // console.log("Adres: ", address, "Lokacja:", location);
  //         }
  //         );
  //       await this.delay(1000);
  //     }
  //     seller.company = entry.company;
  //     seller.city = entry.city;
  //     seller.address = entry.address;
  //     seller.zipcode = entry.zipcode;
  //     seller.palettes.push(entry.palette);
  //     seller.region = entry.region;
  //     seller.region_phone = entry.region_phone;
  //     if (contact.firstname && contact.lastname && contact.firstname != entry.firstname && contact.lastname != entry.lastname) {
  //       seller.contacts.push(contact);
  //       contact = new KanufSellerContact;
  //     }
  //     contact.firstname = entry.firstname;
  //     contact.lastname = entry.lastname;
  //     contact.phone = entry.phone;
  //   }
  //
  //   // console.log(JSON.stringify(sellers));
  // }


  onMarkerClick(marker: MapAdvancedMarker) {
    this.infoWindow.openAdvancedMarkerElement(marker.advancedMarker, marker.advancedMarker.title);
  }


}
